import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '8px 40px',
      gap: 2,
      position: 'sticky',
      bottom: 0,
      background: 'linear-gradient(to right, #0e00fff2, #4fb1ffb5, #883dbfc2, #f906f9)',
    },

    heading: {
      fontSize: '16px',
      lineHeight: '24px',
      color: 'var(--x-bg-1)',
      fontWeight: FontWeight.Regular,

      [mediaQuery(breakpoints.tablet)]: {
        display: 'none',
      },
    },
  }),
  {
    name: 'faq-fixed-section',
  },
);

export default useStyles;
